import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
// components
import MainTemplate from '../../../components/templates/mainTemplate';
import TherapistsTable from '../../../components/organisms/tables/admin/therapists';
import TableContainer from '../../../components/containers/tableContainer';
import { HeaderPageContainer } from '../../../components/containers/pageContainer';
import NavigationContainer from '../../../components/containers/navigationContainer';
import AddTherapist from '../../../components/organisms/modals/addTherapist';
// actions
import appAction from '../../../redux/actions/app';
import therapistsAction from '../../../redux/actions/therapists';
// types
import { FilterOptionsRole } from '../../../types/actions/common-types';

const TherapistsPage: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appAction.page('All Therapists'));
    dispatch(therapistsAction.get());

    return () => {
      dispatch(therapistsAction.setOptionsIsReceived(FilterOptionsRole.Empty));
    };
  }, []);

  return (
    <MainTemplate>
      <HeaderPageContainer>
        <h2 className="text-page-header">All Therapists</h2>
        <AddTherapist />
      </HeaderPageContainer>
      <NavigationContainer name="admin" table="therapists" />
      <TableContainer>
        <TherapistsTable />
      </TableContainer>
    </MainTemplate>
  );
};

export default TherapistsPage;
